import { useCallback } from 'react'

import { useConnect } from 'redux-bundler-hook'

export const useIAmLead = propTask => {
  const { currentMembership, task: storeTask } = useConnect('selectCurrentMembership', 'selectTask')
  const task = propTask ?? storeTask
  return useCallback(() => [
    currentMembership,
    task && task.assigned,
    currentMembership.id && currentMembership.id === task.assigned
  ].every(Boolean), [currentMembership, task])
}
